import { useEffect, useState, useRef, Dispatch, SetStateAction } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import logo from '../../assets/Logo.png';
import logoPhone from '../../assets/logo-width-to600.svg';
import { Breadcrumb, Button, Checkbox, Form, message, Radio, Tooltip } from 'antd';
import arrowRight from '../../assets/arrow-right.svg';
import activeArrow from '../../assets/arrow-right-active.svg';
import general from '../../assets/generalIcon.svg';
import WelcomeBackIcon from '../../assets/WelcomeBackIcon.svg';
import password from '../../assets/PasswordIcon.svg';
import EmailSentImage from '../../assets/EmailSentImage.svg';
import RegistrationDone from '../../assets/Greate.svg';
import ContactInfoIcon from '../../assets/ContactInfoIcon.svg';
import supplierCreated from '../../assets/supplierCreated.svg';
import './index.scss';
import DefaultAvatar from '../../assets/DefaultAvatar.svg';
import RoundedWhite from '../../assets/RoundedWhite.svg';
import done from '../../assets/Done, Check.svg';
import nextEaImage from '../../assets/Interrupted, Line, Circle.png';
import arrowIcon from '../../assets/arrow-right-white.svg';
import timerIcon from '../../assets/clock-time-timer-fast.svg';
import CountdownTimer from '../../components/CountdownTimer';

import {
    useCreateSupplierMutation,
    useLazyGetInvatationDataQuery,
    useSignUpMutation,
    useLazyGetQuestionaryForSupplierRegiatrationFormQuery,
    useSyncEAtoComponentsMutation,
    useSaveAnswersMutation,
    useSendConfirmationCompanyEmailMutation,
    useLazyConfirmCompanyNumberQuery,
    useLazyGetFormDataForEAQuery
} from '../../api/users';
import { FloatInput } from '../../components/Fields/FloatInput';
import { yupSync } from '../../utils';
import { PhoneNumberInput } from '../../components/Fields/PhoneNumberInput';
import { FloatSelect } from '../../components/Fields/FloatSelect';
import * as Yup from 'yup';
import { useAppDispatch } from '../../hooks';
import { setAuthUser } from '../../reducers/auth/authSlice';
import { usePreventSpaceTyping } from '../../hooks/usePreventSpaceTyping';
import { Loader } from '../../components/Loader/Loader';
import { CustomErrorType } from '../../api/types/global';
import i from '../../assets/i.svg';
import { CustomMultiSelect } from '../../components/Fields/CustomMultiSelect';
import { useGetSchoolTypesQuery } from '../../api/common';
import { ArrowLeft } from '../../components/Icons/ArrowLeft';
import { Arrow } from '../../components/Icons/Arrow';
import { FormItem, Section } from '../../api/types/expenseareas';
import { ServiceComIcon } from '../../components/Icons/ServiceComIcon';
import InfoIcon from '../../components/Icons/infoIcon';
import {
    Dropdown,
    ExplanationBanner,
    MultipleChoice,
    Paragraph,
    ShortAnswer,
    SingleSelect
} from './fields/fieldsRender';

interface ExpenseAreaForRender {
    name: string;
    expense_area_id: number;
    order: number;
    sections: Section[];
    status?: 'active' | 'done' | 'pending';
    last_section_id: string | null;
    selected_components: number[];
    expense_area_name: string;
}

type AnswerValue = string | string[];

export interface QuestionAnswer {
    id: number;
    answer: AnswerValue;
    required: boolean;
    error: boolean;
    /** Текст ошибки с бэка (422), показывается под полем */
    errorMessage?: string;
    component_id: number | null;
    type?: string;
    name: string;
    description?: string;
    options?: any;
    component_name?: string;
}

/** Собирает все листовые сообщения в плоский объект dot-path → строки */
const flattenServerErrorsToPaths = (raw: unknown, parts: string[] = [], out: Record<string, string[]> = {}): Record<string, string[]> => {
    if (raw == null) return out;

    if (typeof raw === 'string' || typeof raw === 'number' || typeof raw === 'boolean') {
        const path = parts.join('.');
        if (!path) return out;
        if (!out[path]) out[path] = [];
        out[path].push(String(raw));
        return out;
    }

    if (Array.isArray(raw)) {
        if (raw.length === 0) return out;
        if (raw.every((x) => x == null || ['string', 'number', 'boolean'].includes(typeof x))) {
            const path = parts.join('.');
            if (!path) return out;
            if (!out[path]) out[path] = [];
            for (const x of raw) out[path].push(String(x));
            return out;
        }
        raw.forEach((item, i) => flattenServerErrorsToPaths(item, [...parts, String(i)], out));
        return out;
    }

    if (typeof raw === 'object') {
        for (const [k, v] of Object.entries(raw as Record<string, unknown>)) {
            flattenServerErrorsToPaths(v, [...parts, k], out);
        }
    }
    return out;
};

/** Нормализует массив вида [{ field, message }] и похожие в объект путей */
const normalizeErrorsPayload = (raw: unknown): unknown => {
    if (!Array.isArray(raw)) return raw;

    const rows = raw.filter((x) => x && typeof x === 'object') as Record<string, unknown>[];
    if (
        rows.length > 0 &&
        rows.every((x) => {
            const key = x.field ?? x.key ?? x.attribute;
            return typeof key === 'string' && (x.message != null || x.messages != null || x.msg != null);
        })
    ) {
        const o: Record<string, string[]> = {};
        for (const x of rows) {
            const path = String(x.field ?? x.key ?? x.attribute ?? '');
            if (!path) continue;
            const msg = x.message ?? x.messages ?? x.msg;
            const list = Array.isArray(msg) ? msg.map(String) : [String(msg)];
            if (!o[path]) o[path] = [];
            o[path].push(...list.filter((s) => s && s.trim() !== ''));
        }
        return o;
    }

    return raw;
};

const extractFieldRowSpecifier = (path: string): number | null => {
    const patterns = [
        /\bfields\.(\d+)(?=\.|$|\[)/,
        /\bfields\[(\d+)\]/,
        /\bselected_components\.(\d+)(?=\.|$|\[)/,
        /\bselected_components\[(\d+)\]/
    ];
    for (const re of patterns) {
        const m = path.match(re);
        if (m) return parseInt(m[1], 10);
    }
    return null;
};

const resolveRowIndexForSpecifier = (spec: number, rows: QuestionAnswer[]): number | null => {
    if (spec >= 0 && spec < rows.length) return spec;
    const byId = rows.findIndex((r) => String(r.id) === String(spec));
    return byId >= 0 ? byId : null;
};

type ApplyServerErrorsResult = { next: QuestionAnswer[]; unmapped: string[] };

const applyQuestionaryServerErrors = (prev: QuestionAnswer[], rawErrors: unknown): ApplyServerErrorsResult => {
    const cleared: QuestionAnswer[] = prev.map((item) => ({
        ...item,
        error: false,
        errorMessage: undefined
    }));

    if (rawErrors == null) {
        return { next: cleared, unmapped: [] };
    }

    if (typeof rawErrors === 'string') {
        const t = rawErrors.trim();
        return { next: cleared, unmapped: t ? [t] : [] };
    }

    if (Array.isArray(rawErrors) && rawErrors.length > 0 && rawErrors.every((x) => typeof x === 'string')) {
        const lines = (rawErrors as string[]).map((s) => s.trim()).filter(Boolean);
        return { next: cleared, unmapped: Array.from(new Set(lines)) };
    }

    const normalized = normalizeErrorsPayload(rawErrors);
    const flat = flattenServerErrorsToPaths(normalized);
    const next = [...cleared];
    const unmapped: string[] = [];
    const indexToMsgs = new Map<number, string[]>();

    for (const [path, msgs] of Object.entries(flat)) {
        const trimmed = msgs.map((m) => String(m).trim()).filter(Boolean);
        if (!trimmed.length) continue;

        const spec = extractFieldRowSpecifier(path);
        if (spec == null) {
            unmapped.push(...trimmed);
            continue;
        }
        const rowIndex = resolveRowIndexForSpecifier(spec, next);
        if (rowIndex == null) {
            unmapped.push(...trimmed);
            continue;
        }
        const prevMsg = indexToMsgs.get(rowIndex) ?? [];
        indexToMsgs.set(rowIndex, [...prevMsg, ...trimmed]);
    }

    for (const [rowIndex, messages] of indexToMsgs) {
        const text = Array.from(new Set(messages)).join('; ');
        next[rowIndex] = {
            ...next[rowIndex],
            error: true,
            errorMessage: text || 'Invalid value'
        };
    }

    return { next, unmapped: Array.from(new Set(unmapped)) };
};

const validationSchema = Yup.object().shape({
    contact_name: Yup.string().required('This is a required field'),
    first_name: Yup.string().required('This is a required field'),
    name: Yup.string().required('This is a required field'),
    trading_name: Yup.string(),
    website: Yup.string()
        .required('This is a required field')
        .matches(/^(https?:\/\/)/, 'Oops! Your link is not correct'),
    last_name: Yup.string().required('This is a required field'),
    email: Yup.string().email('Enter your email: e.g. email@domain.com').required('This is a required field'),
    secondary_email: Yup.string().email('Enter your email: e.g. email@domain.com'),
    school: Yup.object().required('This is a required field'),
    b_bbee: Yup.object().required('This is a required field'),
    annual_revenue: Yup.object().required('This is a required field'),
    employees_number: Yup.object().required('This is a required field'),
    sub_regions: Yup.object().required('This is a required field'),
    job: Yup.string().required('This is a required field'),
    phone_number: Yup.string()
        .required('This is a required field')
        .matches(/^[^_]*$/, 'This is a required field'),
    registration_num: Yup.string()
        .required('This is a required field')
        .matches(/^[^_]*$/, 'This is a required field'),
    vat_number: Yup.string()
        .required('This is a required field')
        .matches(/^[^_]*$/, 'This is a required field'),

    password: Yup.string()
        .required('This is a required field')
        .test('password-requirements', '', (value) => {
            const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
            return passwordRegex.test(value);
        }),
    confirmPassword: Yup.string().required('This is a required field')
});

export const SignUp = () => {
    const [getData, { data, isError }] = useLazyGetInvatationDataQuery();
    const location = useLocation();
    const isSupplier = location.pathname.includes('supplier');
    const [searchParams, setSearchParams] = useSearchParams();

    const [getQuestionaryForSupplierRegiatrationForm] = useLazyGetQuestionaryForSupplierRegiatrationFormQuery();
    const [questionary, setQuestionary] = useState<ExpenseAreaForRender[]>([]);

    const [confirmCompanyNumber, { data: companyData }] = useLazyConfirmCompanyNumberQuery();

    const [getDataForExpenseArea, { data: expenseAreaData }] = useLazyGetFormDataForEAQuery();

    const [
        signUp,
        { data: signUpUserData, isSuccess: signUpUserSuccess, isLoading: signUpUserLoading, error: errorsignUpUser }
    ] = useSignUpMutation();

    const [
        createSupplier,
        {
            data: createdData,
            isSuccess,
            isError: isErrorCreateSupplier,
            isLoading: isLoadingCreateSupplier,
            error: createSupplierError
        }
    ] = useCreateSupplierMutation();

    const [syncEAtoComponents, { isLoading: isLoadingSyncComponents }] = useSyncEAtoComponentsMutation();

    const [saveAnswers, { isLoading: isLoadingsaveAnswers }] = useSaveAnswersMutation();

    const [
        sendConfirmationCompanyEmail,
        { data: dataEmailSent, isSuccess: isSuccessEmailSent, isLoading: loadingSendEmail }
    ] = useSendConfirmationCompanyEmailMutation();

    const types = {};

    const { data: dataSchoolTypes } = useGetSchoolTypesQuery(types);

    const navigate = useNavigate();
    const [step, setStep] = useState('general');
    const [imageUrl, setImageUrl] = useState<string>('');
    const [supplierCompanyIdOverride, setSupplierCompanyIdOverride] = useState<string | undefined>(undefined);
    const questionnaireFlowFinishedRef = useRef(false);
    const prevSupplierCompanyIdRef = useRef<string | undefined>(undefined);
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [form] = Form.useForm();
    const [fileAvatar, setFileAvatar] = useState('');
    const [changed, setChanged] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [formDataFormFirstStep, setFormDataFormFirstStep] = useState<any>();
    const dispatch = useAppDispatch();
    const [passwordErr, setPasswordErr] = useState(false);
    const [fileErr, setFileErr] = useState('');
    const { handleKeyPress } = usePreventSpaceTyping();

    const questionaryParams = JSON.parse(sessionStorage.getItem('questionary_params') || 'null');

    const registration_number_token = searchParams.get('registration_number_token');

    const rawSupplierFromSession = questionaryParams?.supplier_company_id;
    const supplier_company_id =
        supplierCompanyIdOverride ??
        (rawSupplierFromSession != null && String(rawSupplierFromSession).trim() !== ''
            ? String(rawSupplierFromSession)
            : undefined);
    const registration_number_token_from_SS =
        questionaryParams?.registration_number_token ?? registration_number_token ?? undefined;

    console.log('step', step);

    const upload_documents = searchParams.get('upload_documents');
    const isUploadDocumentsFlow =
        upload_documents != null &&
        upload_documents !== '' &&
        upload_documents.toLowerCase() !== 'false' &&
        upload_documents !== '0';

    const [selectedArea, setSelectedArea] = useState<any[]>([]);
    const [filtredAreas, setFiltredAreas] = useState<any[]>([]);

    const [selectedProvinnces, setSelectedProvinnces] = useState<any[]>([]);
    const [filtredProvinnces, setFiltredProvinnces] = useState<any[]>([]);

    const [selectedSubRegions, setSelectedSubRegions] = useState<any[]>([]);
    const [filtredSubRegion, setFiltredSubRegion] = useState<any>([]);

    const [selectedEmployees, setSelectedEmployees] = useState<any>();
    const [selectedRevenue, setSelectedRevenue] = useState<any>();
    const [selectedBbee, setSelectedBbee] = useState<any>();
    const [radio, setRadio] = useState<string>('');
    const [touched, setTouched] = useState({
        areas: false,
        provinces: false,
        employees: false,
        revenue: false,
        bbee: false,
        radio: false,
        sub_regions: false
    });
    const [errors, setError] = useState({
        expense_areas: false,
        provinces: false,
        employees: false,
        revenue: false,
        bbee: false,
        agreement: false,
        registration_num: false,
        sub_regions: false,
        radio: false,
        vat_number: false
    });
    /** Текст 422 с бэка для поля VAT (например company.vat_number) */
    const [vatNumberServerError, setVatNumberServerError] = useState<string | null>(null);
    const [checkbox, setCheckbox] = useState(false);
    const [supplierData, setSupplierData] = useState<any>();
    const [expandedAreas, setExpandedAreas] = useState<number[]>([]);
    const [list, setList] = useState<ExpenseAreaForRender[]>([]);
    const [activeSectionId, setActiveSectionId] = useState('');
    const [activeEA, setActiveEA] = useState('');
    const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);

    const [saveData, setSaveData] = useState<any[]>([]);
    /** Сообщения 422 без привязки к fields.N (section_id и т.д.) — над секцией анкеты */
    const [serverQuestionaryError, setServerQuestionaryError] = useState<string | null>(null);

    const EAData: any = list?.find((elem) => elem.expense_area_id + '' === activeEA + '');

    const validateAnswers = (data: any[]) => {
        let isValid = true;

        const updated = data.map((item) => {
            if (!item || typeof item !== 'object') return item;

            const isRequired = item.required;
            const ans = item.answer;

            const isEmptyString = ans === '';
            const isEmptyArray = Array.isArray(ans) && ans.length === 0;

            const hasClientError = isRequired && (isEmptyString || isEmptyArray);

            if (hasClientError) isValid = false;

            return {
                ...item,
                error: Boolean(hasClientError) || Boolean(item.errorMessage),
                errorMessage: hasClientError ? undefined : item.errorMessage
            };
        });

        return { updated, isValid };
    };

    const handleSaveFields = () => {
        setServerQuestionaryError(null);
        const { updated, isValid } = validateAnswers(saveData);

        if (isValid) {
            const cleaned = saveData.map((item) => {
                if (!item || typeof item !== 'object') return item;

                const { required, error, ...rest } = item;
                /* API ожидает answer массивом для dropdown (как multiple-choice). В state храним строку. */
                if (rest.type === 'dropdown') {
                    const ans = rest.answer;
                    const answerForApi =
                        ans === '' || ans == null
                            ? []
                            : Array.isArray(ans)
                            ? ans.filter((v: any) => v != null && v !== '')
                            : [ans];
                    return { ...rest, answer: answerForApi };
                }
                return rest;
            });
            const formData = {
                section_id: activeSectionId,
                fields: cleaned
            };
            const postData = {
                supplier_company_id: supplier_company_id,
                expense_area_id: activeEA,
                data: formData
            };
            saveAnswers(postData)
                .unwrap()
                .then(() => {
                    setServerQuestionaryError(null);
                    questionaryDataSavedFunc();
                })
                .catch((error: any) => {
                    const payload = error?.data ?? {};
                    const serverErrors = payload?.errors;
                    if (serverErrors !== undefined && serverErrors !== null) {
                        const { next, unmapped } = applyQuestionaryServerErrors(saveData as QuestionAnswer[], serverErrors);
                        setSaveData(next);
                        setServerQuestionaryError(unmapped.length ? unmapped.join('\n') : null);
                    } else {
                        setServerQuestionaryError(null);
                    }
                    message.error(
                        payload?.message ?? error?.message ?? 'Could not save your answers. Please try again.'
                    );
                });
        } else {
            setSaveData(updated);
        }
    };

    const updateAnswer = (id: number, value: any, type: string, component_id?: number) => {
        if (type === 'components') {
            setSaveData((prev) =>
                prev.map((item) => {
                    if (item.id === id) {
                        return {
                            ...item,
                            answer: item.answer === 'true' ? 'false' : 'true',
                            error: false,
                            errorMessage: undefined
                        };
                    }
                    return item;
                })
            );
        } else {
            setSaveData((prev) =>
                prev.map((item) => {
                    const isMatch =
                        component_id != null ? item.id === id && item.component_id === component_id : item.id === id;

                    if (!isMatch) return item;

                    switch (type) {
                        case 'short-answer':
                        case 'paragraph':
                            return { ...item, answer: value, error: false, errorMessage: undefined };

                        case 'multiple-choice': {
                            const arr = Array.isArray(item.answer) ? item.answer : [];

                            const updated = arr.includes(value) ? arr.filter((v: any) => v !== value) : [...arr, value];

                            return { ...item, answer: updated, error: false, errorMessage: undefined };
                        }

                        case 'dropdown': {
                            if (value === undefined || value === null) {
                                return { ...item, answer: '', error: false, errorMessage: undefined };
                            }
                            return { ...item, answer: value, error: false, errorMessage: undefined };
                        }

                        case 'single-select':
                            return {
                                ...item,
                                answer: item.answer === value ? '' : value,
                                error: false,
                                errorMessage: undefined
                            };

                        default:
                            return item;
                    }
                })
            );
        }
    };

    useEffect(() => {
        if (companyData && dataSchoolTypes) {
            if (companyData?.next_step === 'submit') {
                setStep('contact_info');
                form.setFieldsValue({
                    contact_name: companyData?.contact?.name,
                    job: companyData?.contact?.job_title,
                    phone_number: companyData?.contact?.phone_number,
                    email: companyData?.contact?.email,
                    secondary_email: companyData?.contact?.secondary_email,
                    name: companyData?.company?.name,
                    trading_name: companyData?.company?.trading_name,
                    registration_num: companyData?.company?.registration_num,
                    website: companyData?.company?.website,
                    expense_areas: companyData?.company?.expense_areas,
                    sub_regions: companyData?.company?.sub_regions
                });
                setSupplierData({
                    name: companyData?.company.name,
                    trading_name: companyData?.company.trading_name,
                    registration_num: companyData?.company.registration_num,
                    website: companyData?.company.website,
                    vat_number: companyData?.company.vat_number
                });

                const selectedAreas = dataSchoolTypes?.data?.supplier_questionnaire_expense_areas.filter((elem: any) =>
                    companyData?.company?.expense_areas.includes(elem.id)
                );

                const selectedProvinces = dataSchoolTypes?.data?.provinces.filter((elem: any) =>
                    companyData?.company?.provinces.includes(elem.id)
                );

                const allSubRegions =
                    dataSchoolTypes?.data?.provinces.flatMap((province: any) => province.sub_regions || []) || [];

                const selectedRegions = allSubRegions?.filter((elem: any) =>
                    companyData?.company?.sub_regions.includes(elem.id)
                );

                const selectedEmployes = dataSchoolTypes?.data?.sc_employees_number?.find(
                    (elem: any) => elem.id === companyData?.company?.employees_number
                );
                const selectedRevenue = dataSchoolTypes?.data?.sc_annual_revenue?.find(
                    (elem: any) => elem.id === companyData?.company?.annual_revenue
                );
                const selectedBBE = dataSchoolTypes?.data?.sc_b_bbee?.find(
                    (elem: any) => elem.id === companyData?.company?.b_bbee
                );

                setRadio(companyData?.company.vat_number ? 'yes' : 'no');
                setSelectedArea(selectedAreas);
                setSelectedProvinnces(selectedProvinces);
                setSelectedEmployees(selectedEmployes);
                setSelectedRevenue(selectedRevenue);
                setSelectedBbee(selectedBBE);
                setSelectedSubRegions(selectedRegions);
            }
        }
    }, [companyData, dataSchoolTypes]);

    const getFormEAData = () => {
        const baseData = {
            supplier_company_id: supplier_company_id,
            expence_area_id: activeEA
        };
        getDataForExpenseArea(baseData);
    };

    useEffect(() => {
        if (activeEA && supplier_company_id) {
            getFormEAData();
        }
    }, [activeEA, supplier_company_id]);

    useEffect(() => {
        if (activeSectionId && expenseAreaData) {
            if (activeSectionId.includes('components')) {
                const savedData: QuestionAnswer[] = [];
                const selectedComponents = expenseAreaData?.selected_components;

                expenseAreaData.components.forEach((elem: any) => {
                    savedData.push({
                        id: +elem.id,
                        answer: selectedComponents.includes(elem.id) ? 'true' : 'false',
                        required: false,
                        error: false,
                        component_id: elem.component_id,
                        type: 'components',
                        name: elem.name,
                        description: elem.description
                    });
                });

                setSaveData(savedData);
                setServerQuestionaryError(null);
            } else {
                const findSection = expenseAreaData?.formData?.sections.find(
                    (elem: any) => elem.id + '' === activeSectionId + ''
                );
                if (!findSection) return;
                const fields = findSection?.fields;

                const savedData: any[] = [];

                fields?.forEach((elem: FormItem) => {
                    const required =
                        elem?.settings.find((setting) => setting?.type === 'required')?.switchValue ?? false;

                    if (elem.type === 'short-answer' || elem.type === 'paragraph' || elem.type === 'single-select') {
                        savedData.push({
                            ...elem,
                            answer: elem?.answer ? elem?.answer : '',
                            required: required,
                            error: false,
                            name: elem.label
                        });
                    }
                    if (elem.type === 'multiple-choice' || elem.type === 'dropdown') {
                        savedData.push({
                            ...elem,
                            answer: elem?.answer ? elem?.answer : '',
                            required: required,
                            error: false,
                            name: elem.label
                        });
                    }
                    if (elem.type === 'explanation-banner') {
                        savedData.push({
                            ...elem,
                            answer: elem?.answer ? elem?.answer : '',
                            required: required,
                            error: false,
                            name: elem.label
                        });
                    }
                });
                setSaveData(savedData);
                setServerQuestionaryError(null);
            }
        }
    }, [activeSectionId, expenseAreaData]);

    useEffect(() => {
        if (isSuccessEmailSent && dataEmailSent) {
            setStep('email-sent');
            setIsButtonDisabled(true);
        }
    }, [isSuccessEmailSent, dataEmailSent]);

    const syncEAtoComponentsFunc = () => {
        setServerQuestionaryError(null);
        const postData = {
            supplier_company_id: supplier_company_id,
            expense_area_id: activeEA,
            data: { selected_components: saveData?.filter((elem) => elem.answer === 'true')?.map((elem) => elem.id) }
        };
        syncEAtoComponents(postData)
            .unwrap()
            .then(() => {
                setServerQuestionaryError(null);
                questionaryDataSavedFunc();
            })
            .catch((error: any) => {
                const payload = error?.data ?? {};
                const serverErrors = payload?.errors;
                if (serverErrors !== undefined && serverErrors !== null) {
                    const { next, unmapped } = applyQuestionaryServerErrors(
                        saveData as QuestionAnswer[],
                        serverErrors
                    );
                    setSaveData(next);
                    setServerQuestionaryError(unmapped.length ? unmapped.join('\n') : null);
                } else {
                    setServerQuestionaryError(null);
                }
                message.error(
                    error?.data?.message ?? error?.message ?? 'Could not save components. Please try again.'
                );
            });
    };

    const toggleArea = (id: number) => {
        setExpandedAreas((prev) => (prev.includes(id) ? prev.filter((eid) => eid !== id) : [...prev, id]));
    };

    function applyStatusByLastSection(data: any, goToSections: number[]): ExpenseAreaForRender[] {
        const cloned = data?.map((elem: any) => {
            const lastSectionId = elem.progressData?.last_section_id;

            return {
                name: elem.expense_area_name,
                description: elem.description,
                expense_area_id: elem.expense_area_id,
                last_section_id: lastSectionId,
                order: elem.order,
                selected_components: elem.selected_components,
                sections: [
                    {
                        id: `components-${elem.expense_area_id}`,
                        name: 'Service Components',
                        order: null
                    },
                    ...elem.formData.sections
                        .filter((section: Section) => {
                            if (!section.has_go_to) {
                                return true;
                            }

                            if (section.has_go_to && goToSections.includes(section.order)) {
                                return true;
                            }

                            return false;
                        })
                        .map((section: Section) => ({
                            name: section.title,
                            id: section.id + '',
                            order: section.order,
                            description: section.description
                        }))
                ]
            };
        });

        return cloned;
    }

    function goToPrevSection() {
        const currentEAIndex = list?.findIndex((elem: any) => elem.expense_area_id + '' === activeEA + '');
        const currentArea = list[currentEAIndex];

        const sections = currentArea?.sections;
        const currentAreaIndex = list.findIndex((elem) => elem.expense_area_id + '' === activeEA + '');
        const prevAreaIndex = currentAreaIndex === 0 ? 0 : currentAreaIndex - 1;

        const prevAreaSections = list[prevAreaIndex].sections;
        const lastSection = prevAreaSections[prevAreaSections.length - 1];

        if (activeSectionId.includes('components')) {
            setActiveEA(list[prevAreaIndex]?.expense_area_id + '');
            setActiveSectionId(lastSection.id + '');
        } else {
            const currentIndex = sections?.findIndex((s: Section) => s.id + '' === activeSectionId + '');

            // 👉 если это первая секция первой области — не двигаемся
            if (currentAreaIndex === 0 && currentIndex === 0) return;

            // 👉 если есть предыдущая секция в этой же области
            if (currentIndex > 0) {
                const prevSec = sections[currentIndex - 1];
                setActiveSectionId(prevSec.id + '');
                return;
            }

            if (currentIndex === 0) {
                const currentArea = list.find((elem) => elem.expense_area_id + '' === activeEA + '')?.expense_area_id;
                setActiveEA(currentArea + '');
                setActiveSectionId(`components-${currentArea}`);
            }
        }
    }

    function goToNextSection(list: ExpenseAreaForRender[]) {
        const currentAreaIndex = list.findIndex((elem) => elem.expense_area_id + '' === activeEA + '');
        const currentArea = list[currentAreaIndex];
        const sections = currentArea?.sections;

        const currentIndex = sections.findIndex((s) => s.id + '' === activeSectionId + '');
        const isLastSection = currentIndex === sections.length - 1;

        const lastEAindex = list.length - 1;
        const lastSectionIndex = list[lastEAindex]?.sections.length - 1;
        const lastSectionIdLastEAId = list[lastEAindex]?.sections[lastSectionIndex]?.id;

        const isTheLastSection = activeSectionId + '' === lastSectionIdLastEAId + '';

        if (isTheLastSection) {
            questionnaireFlowFinishedRef.current = true;
            setSupplierCompanyIdOverride(undefined);
            if (!isUploadDocumentsFlow) {
                sessionStorage.removeItem('questionary_params');
            }
            setSearchParams({}, { replace: true });

            if (isUploadDocumentsFlow) {
                setStep('profile_updated_successfully_but_need_documents');
            } else if (!registration_number_token_from_SS) {
                setStep('registration_request_is_in');
            } else {
                setStep('profile_updated_successfully');
            }
            return;
        }

        // 👉 если это последняя секция последней области — не двигаемся
        if (currentAreaIndex === list.length - 1 && isLastSection) return;

        // 👉 если это компоненты внутри области — идём к первой обычной секции
        if (activeSectionId.includes('components')) {
            if (sections.length > 1) {
                const nextSec = sections[1];
                setActiveSectionId(nextSec.id + '');
                return;
            }
        }

        // 👉 если есть следующая секция в этой же области
        if (!isLastSection) {
            const nextSec = sections[currentIndex + 1];
            setActiveSectionId(nextSec.id + '');
            return;
        }

        // 👉 если это последняя секция — переходим к компонентам следующей области
        const nextAreaIndex = currentAreaIndex + 1;
        const nextArea = list[nextAreaIndex];

        if (nextArea) {
            const nextAreaId = nextArea.expense_area_id;
            setActiveEA(nextAreaId + '');
            setActiveSectionId(`components-${nextAreaId}`);
        }
        const container = document.querySelector('.fields-section__components');

        container?.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    useEffect(() => {
        if (!isErrorCreateSupplier) return;
        const data = (createSupplierError as CustomErrorType | undefined)?.data;
        const serverErrors = data?.errors as Record<string, string | string[]> | undefined;
        const vatRaw = serverErrors?.['company.vat_number'];
        const vatMsg = Array.isArray(vatRaw)
            ? vatRaw.filter(Boolean).join(' ')
            : typeof vatRaw === 'string'
              ? vatRaw
              : '';

        if (vatMsg) {
            setVatNumberServerError(vatMsg);
            setError((prev) => ({ ...prev, vat_number: true, registration_num: false }));
            return;
        }

        setVatNumberServerError(null);
        setError((prev) => ({ ...prev, registration_num: true, vat_number: false }));
    }, [isErrorCreateSupplier, createSupplierError]);

    const questionaryDataSavedFunc = () => {
        message.success('Changes saved successfully!');
        getQuestionaryForSupplierRegiatrationForm({ supplier_company_id: supplier_company_id }).then((res) => {
            const goToSections: any = [];
            res.data?.[0]?.formData?.sections?.forEach((elem: Section) => {
                elem.fields?.forEach((field: any) => {
                    const go_to_section = field?.settings?.find((set: any) => set.type === 'go_to_section');
                    if (go_to_section && go_to_section?.switchValue) {
                        field.options?.forEach((opt: any) => {
                            if (opt.selected) {
                                goToSections.push(opt.go_to_next_section);
                            }
                        });
                    }
                });
            });
            const areasWithStatus: ExpenseAreaForRender[] = applyStatusByLastSection(res.data, goToSections);

            setList(areasWithStatus);
            getFormEAData();
            goToNextSection(areasWithStatus);
        });
    };

    useEffect(() => {
        if (isSuccess && createdData) {
            setVatNumberServerError(null);
            setError((prev) => ({ ...prev, vat_number: false, registration_num: false }));
            if (createdData?.data?.next_step === 'submit') {
                setStep((prev) => (prev === 'contact_info' ? 'supplier_created' : 'contact_info'));
            } else {
                setStep(createdData?.data?.next_step);

                if (createdData?.data?.next_step === 'questionary') {
                    const newSupplierId = createdData?.data?.supplier_company?.id;
                    const baseData = {
                        supplier_company_id: newSupplierId
                    };

                    const params = {
                        supplier_company_id: newSupplierId,
                        registration_number_token: registration_number_token || null
                    };

                    sessionStorage.setItem('questionary_params', JSON.stringify(params));
                    if (newSupplierId != null && String(newSupplierId).trim() !== '') {
                        setSupplierCompanyIdOverride(String(newSupplierId));
                    }

                    getQuestionaryForSupplierRegiatrationForm(baseData);
                }
            }
        }
        // intentionally omit registration_number_token: avoid re-running when only search params change while createdData is still set
    }, [isSuccess, createdData]);

    useEffect(() => {
        if (prevSupplierCompanyIdRef.current !== supplier_company_id) {
            prevSupplierCompanyIdRef.current = supplier_company_id;
            questionnaireFlowFinishedRef.current = false;
        }
    }, [supplier_company_id]);

    useEffect(() => {
        if (!supplier_company_id || questionnaireFlowFinishedRef.current) return;

        getQuestionaryForSupplierRegiatrationForm({ supplier_company_id: supplier_company_id }).then((res) => {
            const updatedData = res?.data?.map((EA: any) => {
                return {
                    ...EA,
                    formData: EA.formData?.sections.filter((sec: Section) => !sec?.has_go_to)
                };
            });
            setQuestionary(updatedData);
            const goToSections: any = [];
            res.data?.[0]?.formData?.sections?.forEach((elem: Section) => {
                elem.fields?.forEach((field: any) => {
                    const go_to_section = field?.settings?.find((set: any) => set.type === 'go_to_section');
                    if (go_to_section && go_to_section?.switchValue) {
                        field.options?.forEach((opt: any) => {
                            if (opt.selected) {
                                goToSections.push(opt.go_to_next_section);
                            }
                        });
                    }
                });
            });
            const areasWithStatus = applyStatusByLastSection(res.data, goToSections);

            setList(areasWithStatus);

            for (const EA of areasWithStatus) {
                const lastCompletedSectionId = EA.last_section_id;

                const indexLastCompletedSectionId = EA?.sections.findIndex(
                    (section: Section) => section.id === lastCompletedSectionId + ''
                );
                const lastSectionId = EA?.sections[EA?.sections?.length - 1]?.id;
                const isAllSectionsDone = lastSectionId === lastCompletedSectionId + '';

                const theLatestAreaId = areasWithStatus?.[areasWithStatus?.length - 1]?.expense_area_id;

                const theLatestSectionId =
                    areasWithStatus?.[areasWithStatus?.length - 1]?.sections?.[
                        areasWithStatus?.[areasWithStatus?.length - 1]?.sections?.length - 1
                    ]?.id;

                if (!EA.selected_components?.length) {
                    setActiveSectionId(EA?.sections[0]?.id);
                    setActiveEA(EA.expense_area_id + '');
                    break;
                } else if (!lastCompletedSectionId) {
                    setActiveSectionId(EA?.sections[1]?.id + '');
                    setActiveEA(EA.expense_area_id + '');

                    break;
                } else if (!isAllSectionsDone) {
                    const nextSectionIndex = indexLastCompletedSectionId + 1;
                    setActiveSectionId(EA?.sections[nextSectionIndex]?.id + '');
                    setActiveEA(EA.expense_area_id + '');

                    break;
                } else if (isAllSectionsDone && theLatestAreaId + '' === EA.expense_area_id + '') {
                    setActiveSectionId(theLatestSectionId + '');
                    setActiveEA(EA.expense_area_id + '');
                }
            }
        });
        setStep('questionary');
    }, [supplier_company_id]);

    useEffect(() => {
        if (dataSchoolTypes?.data?.supplier_questionnaire_expense_areas) {
            setFiltredAreas(dataSchoolTypes?.data?.supplier_questionnaire_expense_areas);
        }
    }, [dataSchoolTypes?.data?.supplier_questionnaire_expense_areas]);

    useEffect(() => {
        if (dataSchoolTypes?.data?.provinces) {
            setFiltredProvinnces(dataSchoolTypes?.data?.provinces);
        }
    }, [dataSchoolTypes?.data?.provinces]);

    const deleteItem = (
        id: string | number,
        setSelectedItems: Dispatch<SetStateAction<any[]>>,
        selectedItem: any[]
    ) => {
        const areas = [...selectedItem];
        const filteredArray: any = areas.filter((item) => item.id !== id);
        setSelectedItems(filteredArray);
    };

    const selectItem = (
        area: any,
        setFiltredArray: Dispatch<SetStateAction<any[]>>,
        setSelectedItems: Dispatch<SetStateAction<any[]>>,
        selectedItem: any[],
        data: any[]
    ) => {
        if (area.id === 'selectedAll') {
            const ids = data?.map((elem: any) => elem);
            setFiltredArray([]);
            setSelectedItems(ids);
        } else {
            const newSelectedAreas = [...selectedItem, area];
            setSelectedItems(newSelectedAreas);
        }
    };

    useEffect(() => {
        if (checkbox) {
            setError((prev) => ({ ...prev, agreement: false }));
        }
        if (!selectedArea.length && touched.areas) {
            setError((prev) => ({ ...prev, expense_areas: true }));
        } else {
            setError((prev) => ({ ...prev, expense_areas: false }));
        }
        if (!selectedEmployees && touched.employees) {
            setError((prev) => ({ ...prev, employees: true }));
        } else {
            setError((prev) => ({ ...prev, employees: false }));
        }
        if (!selectedRevenue && touched.revenue) {
            setError((prev) => ({ ...prev, revenue: true }));
        } else {
            setError((prev) => ({ ...prev, revenue: false }));
        }
        if (!selectedBbee && touched.bbee) {
            setError((prev) => ({ ...prev, bbee: true }));
        } else {
            setError((prev) => ({ ...prev, bbee: false }));
        }
        if (!selectedProvinnces.length && touched.provinces) {
            setError((prev) => ({ ...prev, provinces: true }));
        } else {
            setError((prev) => ({ ...prev, provinces: false }));
        }
        if (!selectedSubRegions.length && touched.sub_regions) {
            setError((prev) => ({ ...prev, sub_regions: true }));
        } else {
            setError((prev) => ({ ...prev, sub_regions: false }));
        }
        if (!radio && touched.radio) {
            setError((prev) => ({ ...prev, radio: true }));
        } else {
            setError((prev) => ({ ...prev, radio: false }));
        }

        if (!dataSchoolTypes?.data?.supplier_questionnaire_expense_areas) return;
        const areas = [...dataSchoolTypes?.data?.supplier_questionnaire_expense_areas];
        const filteredArray: any = areas.filter(
            (item) =>
                !selectedArea.some((secondItem) => {
                    return secondItem.id === item.id;
                })
        );
        setFiltredAreas(filteredArray);
    }, [
        selectedArea,
        dataSchoolTypes?.data?.supplier_questionnaire_expense_areas,
        selectedEmployees,
        selectedProvinnces,
        selectedRevenue,
        selectedBbee,
        selectedSubRegions,
        touched,
        checkbox,
        radio
    ]);

    useEffect(() => {
        if (!dataSchoolTypes?.data?.provinces) return;
        const provinces = [...dataSchoolTypes?.data?.provinces];
        const filteredArray: any = provinces.filter(
            (item) =>
                !selectedProvinnces.some((secondItem) => {
                    return secondItem.id === item.id;
                })
        );
        const newSubRegions = [...selectedSubRegions];
        const selectedProvinceIds = selectedProvinnces?.map((item) => item.id) ?? [];
        const filterSelectedSubRegions = newSubRegions?.filter((elem) =>
            selectedProvinceIds.includes(elem.province_id)
        );

        setFiltredProvinnces(filteredArray);

        if (!selectedSubRegions.length) return;
        setSelectedSubRegions(filterSelectedSubRegions);
    }, [selectedProvinnces, dataSchoolTypes?.data?.provinces]);

    useEffect(() => {
        if (!dataSchoolTypes?.data?.provinces) return;

        const provinces = [...dataSchoolTypes?.data?.provinces];

        let subRegionsArray: any[] = [];
        const selectedProvIds = selectedProvinnces.map((elem) => elem.id);
        provinces.forEach((elem) => {
            if (selectedProvIds.includes(elem.id)) {
                subRegionsArray.push(...elem.sub_regions);
            }
        });

        const filteredArraySubRegions = subRegionsArray?.filter(
            (item) =>
                !selectedSubRegions.some((secondItem) => {
                    return secondItem.id === item.id;
                })
        );
        setFiltredSubRegion(filteredArraySubRegions);
    }, [selectedProvinnces, selectedSubRegions]);

    const [screenWidth, setScreenWidth] = useState<number>(window.screen.width);
    function handleResize() {
        setScreenWidth(window.screen.width);
    }

    window.addEventListener('resize', handleResize);

    useEffect(() => {
        if (isError) {
            navigate('/expired');
        }
    }, [isError]);

    useEffect(() => {
        if (!data) return;

        if (data?.data?.role?.name === 'school_user') {
            form.setFieldsValue({
                //@ts-ignore
                first_name: data.data.first_name ? data.data.first_name : '',
                last_name: data.data.last_name ? data.data.last_name : '',
                email: data.data.email,
                phone_number: data.data.phone_number ? data.data.phone_number : '',
                school: data.data.school,
                job: data.data.job_title ? data.data.job_title : ''
            });
        }
        if (
            data?.data?.role?.name === 'tender_representative' ||
            data?.data?.role?.title === 'Super Admin' ||
            data?.data?.role?.title === 'Onboarding Representative'
        ) {
            form.setFieldsValue({
                //@ts-ignore
                first_name: data.data.first_name ? data.data.first_name : '',
                last_name: data.data.last_name ? data.data.last_name : '',
                email: data.data.email
            });
        }
        setImageUrl(data.data.avatar);
    }, [data]);

    const getInvitationData = async () => {
        try {
            await getData(searchParams.get('token'));
        } catch {
            navigate('/expired');
        }
    };

    useEffect(() => {
        if (!location) return;
        if (location?.search.includes('registration_number_token')) {
            if (searchParams.get('registration_number_token')) {
                const signature = searchParams.get('registration_number_token');
                confirmCompanyNumber(signature);
            }
        } else {
            if (searchParams.get('token')) {
                getInvitationData();
            }
        }
    }, [searchParams, location]);

    const handleFileChange = (event: any) => {
        const allowedTypes = ['image/jpeg', 'image/png', 'image/heic', 'image/jpg'];
        const maxFileSize = 5 * 1024 * 1024;
        const file = event.target.files[0];

        if (file && allowedTypes?.includes(file.type) && file.size < maxFileSize) {
            setChanged(true);
            setImageUrl(URL.createObjectURL(event.target.files[0]));
            setFileAvatar(event.target.files[0]);
            setFileErr('');
        } else {
            if (!allowedTypes?.includes(file.type)) {
                setFileErr('You can upload files in the following formats: .jpg, .jpeg, .png, .heic');
            }
            if (file.size > maxFileSize) {
                setFileErr('The file size limit is 5 MB');
            }
            event.target.value = '';
        }
    };

    const clickUpload = () => {
        fileInputRef?.current?.click();
    };
    const validationHandler = async (params: any) => {
        const signUpData = {
            token: searchParams.get('token'),
            data: params
        };
        try {
            await signUp(signUpData);

            setStep('password');
        } catch {
            messageApi.error('Something went wrong!');
            // navigate('/expired');
        }
    };

    useEffect(() => {
        if (signUpUserSuccess && step === 'password' && signUpUserData) {
            dispatch(
                setAuthUser({
                    authToken: signUpUserData.data?.access_token,
                    id: null,
                    name: null,
                    email: null
                })
            );
            navigate('/dashboard');
        }
    }, [signUpUserSuccess, signUpUserData]);

    const signUpHandler = async (params: any) => {
        const signUpData = {
            token: searchParams.get('token'),
            data: params
        };
        try {
            await signUp(signUpData).unwrap();
            await messageApi.success('You have successfully registered');
        } catch {}
    };

    useEffect(() => {
        if (errorsignUpUser) {
            if ((errorsignUpUser as CustomErrorType)?.data?.message === 'The Password format is invalid') {
                messageApi.error('The Password format is invalid');
            }
        }
    }, [errorsignUpUser]);

    const handleSubmit = () => {
        let isValid = true;
        const errorObj = { ...errors };
        setTouched({
            areas: true,
            provinces: true,
            employees: true,
            revenue: true,
            bbee: true,
            sub_regions: true,
            radio: true
        });
        if (isSupplier) {
            if (step === 'contact_info' && !checkbox) {
                errorObj.agreement = true;
                isValid = false;
            }
            if (selectedArea.length === 0) {
                errorObj.expense_areas = true;
                isValid = false;
            }
            if (selectedProvinnces.length === 0) {
                errorObj.provinces = true;
                isValid = false;
            }
            if (!selectedEmployees) {
                errorObj.employees = true;
                isValid = false;
            }
            if (!selectedRevenue) {
                errorObj.revenue = true;
                isValid = false;
            }
            if (!selectedBbee) {
                errorObj.bbee = true;
                isValid = false;
            }
            if (selectedSubRegions.length === 0) {
                errorObj.sub_regions = true;
                isValid = false;
            }
            if (!radio) {
                errorObj.radio = true;
                isValid = false;
            }
            setError(errorObj);
        }
        form.validateFields()
            .then((values: any) => {
                if (!isValid) return;
                if (step === 'general') {
                    if (isSupplier) {
                        const data = {
                            step: 'check-company',
                            data: {
                                company: {
                                    name: values.name,
                                    trading_name: values.trading_name,
                                    registration_num: values.registration_num,
                                    website: values.website,
                                    expense_areas: selectedArea?.map((elem: any) => elem.id),
                                    provinces: selectedProvinnces?.map((elem: any) => elem.id),
                                    sub_regions: selectedSubRegions?.map((elem) => elem.id),
                                    employees_number: selectedEmployees?.id,
                                    b_bbee: selectedBbee?.id,
                                    annual_revenue: selectedRevenue?.id,
                                    has_vat_number: radio === 'yes',
                                    vat_number: radio === 'yes' ? values.vat_number : null
                                }
                            }
                        };

                        setSupplierData({
                            name: values.name,
                            trading_name: values.trading_name,
                            registration_num: values.registration_num,
                            website: values.website,
                            vat_number: radio === 'yes' ? values.vat_number : null
                        });

                        createSupplier(data);
                    } else {
                        const formData = new FormData();
                        formData.append('step', step);
                        formData.append('first_name', values.first_name.trim());
                        formData.append('last_name', values.last_name.trim());
                        formData.append('role', data.data.role.name);

                        if (data?.data?.role?.name === 'school_user') {
                            formData.append('phone_number', values.phone_number);
                            formData.append('job_title', values.job.trim());
                        }

                        if (changed && fileAvatar) {
                            formData.append('avatar', fileAvatar);
                        }
                        if (changed && !fileAvatar) {
                            formData.append('reset_avatar', '1');
                        }

                        const object: any = {
                            first_name: values.first_name.trim(),
                            last_name: values.last_name.trim(),
                            role: data.data.role.name
                        };

                        if (data?.data?.role?.name === 'school_user') {
                            object.phone_number = values.phone_number;
                            object.job_title = values.job.trim();
                        }

                        if (changed && fileAvatar) {
                            object.avatar = fileAvatar;
                        }
                        if (changed && !fileAvatar) {
                            object.reset_avatar = 1;
                        }
                        setFormDataFormFirstStep(object);
                        validationHandler(formData);
                    }
                }
                if (step === 'password') {
                    const formData = new FormData();
                    formData.append('password', values.password);
                    formData.append('password_confirmation', values.confirmPassword);
                    formData.append('step', step);
                    formData.append('first_name', formDataFormFirstStep?.first_name);
                    formData.append('last_name', formDataFormFirstStep?.last_name);
                    formData.append('role', data.data.role.name);
                    if (data?.data?.role?.name === 'school_user') {
                        formData.append('phone_number', formDataFormFirstStep?.phone_number);
                        formData.append('job_title', formDataFormFirstStep?.job_title);
                    }

                    if (formDataFormFirstStep.avatar) {
                        formData.append('avatar', formDataFormFirstStep.avatar);
                    }
                    if (!formDataFormFirstStep.avatar && !imageUrl) {
                        formData.append('reset_avatar', '1');
                    }
                    signUpHandler(formData);
                }
                if (step === 'contact_info') {
                    const data = {
                        step: 'submit',
                        data: {
                            company: {
                                name: supplierData.name,
                                trading_name: supplierData.trading_name,
                                registration_num: supplierData.registration_num,
                                website: supplierData.website,
                                expense_areas: selectedArea?.map((elem: any) => elem.id),
                                provinces: selectedProvinnces?.map((elem: any) => elem.id),
                                employees_number: selectedEmployees?.id,
                                b_bbee: selectedBbee?.id,
                                annual_revenue: selectedRevenue?.id,
                                sub_regions: selectedSubRegions?.map((elem) => elem.id),
                                has_vat_number: radio === 'yes',
                                vat_number: radio === 'yes' ? supplierData.vat_number : null
                            },
                            contact: {
                                name: values.contact_name,
                                job_title: values.job,
                                email: values.email,
                                secondary_email: values.secondary_email,
                                phone_number: values.phone_number
                            },
                            agreement: checkbox
                        }
                    };
                    createSupplier(data);
                }
            })
            .catch((errors) => {
                errors?.errorFields?.map((elem: any) => {
                    if (elem.name[0] === 'password') {
                        if (elem.errors[0] === '') {
                            setPasswordErr(true);
                        } else {
                            setPasswordErr(false);
                        }
                    }
                });
                const element = errors?.errorFields?.find((elem: any) => elem.name[0] === 'password');
                if (!element) {
                    setPasswordErr(false);
                }
            });
    };

    return (
        <>
            {contextHolder}
            <div className="signup">
                <div className="signup__header header">
                    {screenWidth > 600 && <img src={logo} className="header__logo" />}
                    {screenWidth <= 600 && <img src={logoPhone} className="header__logo" />}
                    {step === 'supplier_created' ||
                    step === 'registration_request_is_in' ||
                    step === 'email-sent' ||
                    step === 'profile_updated_successfully' ||
                    step === 'profile_updated_successfully_but_need_documents' ||
                    step === 'notify-contact' ||
                    step === 'email-sent' ? (
                        <></>
                    ) : (
                        <div className="header__breadcrumb">
                            <Breadcrumb
                                items={
                                    isSupplier
                                        ? [
                                              {
                                                  title: (
                                                      <div
                                                          className={`header__item active`}
                                                          onClick={() => {
                                                              if (
                                                                  registration_number_token_from_SS ||
                                                                  step === 'questionary'
                                                              ) {
                                                                  return;
                                                              } else {
                                                                  setStep('general');
                                                              }
                                                          }}
                                                          style={{ cursor: 'pointer' }}
                                                      >
                                                          <span>Company Info</span>
                                                      </div>
                                                  )
                                              },
                                              {
                                                  title: (
                                                      <div
                                                          className={`header__item ${
                                                              step === 'contact_info' || step === 'questionary'
                                                                  ? 'active'
                                                                  : ''
                                                          }`}
                                                      >
                                                          <img
                                                              src={
                                                                  step === 'contact_info' || step === 'questionary'
                                                                      ? activeArrow
                                                                      : arrowRight
                                                              }
                                                              style={{ margin: '0 10px 0 0' }}
                                                          />
                                                          <span>Contact Info</span>
                                                      </div>
                                                  )
                                              },
                                              {
                                                  title: (
                                                      <div
                                                          className={`header__item ${
                                                              step === 'questionary' ? 'active' : ''
                                                          }`}
                                                      >
                                                          <img
                                                              src={
                                                                  step === 'contact_info' || step === 'questionary'
                                                                      ? activeArrow
                                                                      : arrowRight
                                                              }
                                                              style={{ margin: '0 10px 0 0' }}
                                                          />
                                                          <span>Expense Area Questionnaire</span>
                                                      </div>
                                                  )
                                              },
                                              {
                                                  title: (
                                                      <div className="header__item">
                                                          <span style={{ visibility: 'hidden' }}>ssegeg</span>
                                                      </div>
                                                  )
                                              }
                                          ]
                                        : [
                                              {
                                                  title: (
                                                      <div
                                                          className={`header__item active`}
                                                          onClick={() => setStep('general')}
                                                          style={{ cursor: 'pointer' }}
                                                      >
                                                          <span>Personal Info</span>
                                                      </div>
                                                  )
                                              },
                                              {
                                                  title: (
                                                      <div
                                                          className={`header__item ${
                                                              step === 'password' ? 'active' : ''
                                                          }`}
                                                      >
                                                          <img
                                                              src={step === 'password' ? activeArrow : arrowRight}
                                                              style={{ margin: '0 10px 0 0' }}
                                                          />
                                                          <span>Password</span>
                                                      </div>
                                                  )
                                              },
                                              {
                                                  title: (
                                                      <div className="header__item">
                                                          <img src={arrowRight} />
                                                          <span style={{ visibility: 'hidden' }}>ssegeg</span>
                                                      </div>
                                                  )
                                              }
                                          ]
                                }
                            />
                        </div>
                    )}
                </div>
                <div className="signup__main main">
                    {step === 'general' && (
                        <div className="main__block">
                            <div className="main__form form">
                                {isSupplier ? (
                                    <div className="form__title">
                                        Supplier Registration for
                                        <br /> Matchmaking Journey Notifications
                                    </div>
                                ) : (
                                    <div className="form__title">
                                        Welcome to the Hive! <br />
                                        Your Matchmaking Journey collaboration space!
                                    </div>
                                )}
                                {isSupplier ? (
                                    <div className="form__subtitle">
                                        Please complete the section General Company Info
                                    </div>
                                ) : (
                                    <div className="form__subtitle">Please fill in personal data</div>
                                )}

                                {!isSupplier && (
                                    <div className="form__addbtn">
                                        {imageUrl && (
                                            <img
                                                src={RoundedWhite}
                                                className="form__delete-avatar-btn"
                                                onClick={() => {
                                                    setChanged(true);
                                                    setImageUrl('');
                                                }}
                                            />
                                        )}
                                        <input
                                            type="file"
                                            accept=".jpg, .jpeg, .png, .heic"
                                            onChange={handleFileChange}
                                            style={{ display: 'none' }}
                                            ref={fileInputRef}
                                        />

                                        {imageUrl ? (
                                            <img src={imageUrl} alt="avatar" className="upload-image" />
                                        ) : (
                                            <img src={DefaultAvatar} />
                                        )}

                                        <div className="form__addtext" onClick={clickUpload}>
                                            {imageUrl ? 'Edit Photo' : 'Add Photo'}
                                        </div>
                                    </div>
                                )}
                                {fileErr && <div className="fields__file-error">{fileErr}</div>}
                                {isSupplier && (
                                    <div className="form__note">
                                        <img src={i} />
                                        <div>
                                            If you have separate legal entities operating in different expense areas
                                            (e.g., Cleaning, Security), please complete a form for each relevant entity.
                                        </div>
                                    </div>
                                )}

                                {data?.data?.role?.name === 'school_user' && (
                                    <div className="signup__fields fields">
                                        <div className="fields__subtitle">All fields are mandatory</div>
                                        <Form form={form} onFinish={handleSubmit} validateTrigger="onBlur">
                                            <div className="fields__block">
                                                <div className="fields__row">
                                                    <Form.Item
                                                        className={`${
                                                            screenWidth > 600 ? 'small-input-wrapper' : 'input-wrapper'
                                                        }`}
                                                        name="first_name"
                                                        rules={yupSync('first_name', validationSchema, true)}
                                                    >
                                                        <FloatInput
                                                            floatLabel="First Name"
                                                            className="input"
                                                            maxLength={60}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item
                                                        className={`${
                                                            screenWidth > 600 ? 'small-input-wrapper' : 'input-wrapper'
                                                        }`}
                                                        name="last_name"
                                                        rules={yupSync('last_name', validationSchema, true)}
                                                    >
                                                        <FloatInput
                                                            floatLabel="Last Name"
                                                            className="input"
                                                            maxLength={60}
                                                        />
                                                    </Form.Item>
                                                </div>

                                                <Form.Item
                                                    className="input-wrapper"
                                                    name="email"
                                                    rules={yupSync('email', validationSchema, true)}
                                                >
                                                    <FloatInput
                                                        floatLabel="Email"
                                                        className="input"
                                                        maxLength={60}
                                                        required={true}
                                                        disabled={true}
                                                        onKeyPress={handleKeyPress}
                                                    />
                                                </Form.Item>
                                                <Form.Item
                                                    className="input-wrapper"
                                                    name="phone_number"
                                                    rules={yupSync('phone_number', validationSchema, true)}
                                                >
                                                    <PhoneNumberInput
                                                        floatLabel="Phone Number"
                                                        className="input"
                                                        maxLength={256}
                                                        value={data?.data?.phone_number}
                                                        placeholder={undefined}
                                                        required={undefined}
                                                        onChange={() => {}}
                                                        hasError={() => !!form.getFieldError('phone_number').length}
                                                        onBlur={() => yupSync('phone_number', validationSchema, true)}
                                                    />
                                                </Form.Item>
                                            </div>
                                            <div className="fields__block">
                                                <Form.Item
                                                    className="input-wrapper"
                                                    name="school"
                                                    rules={yupSync('school', validationSchema, true)}
                                                >
                                                    <FloatSelect
                                                        search={''}
                                                        floatLabel="Organisation"
                                                        className="input-select"
                                                        required={true}
                                                        err={false}
                                                        setSearch={() => {}}
                                                        options={[]}
                                                        onChange={''}
                                                        value={data?.data?.school}
                                                        form={form}
                                                        disabled={true}
                                                        hasError={() => false}
                                                    />
                                                </Form.Item>
                                            </div>
                                            <div className="fields__block">
                                                <Form.Item
                                                    className="input-wrapper"
                                                    name="job"
                                                    rules={yupSync('job', validationSchema, true)}
                                                >
                                                    <FloatInput
                                                        floatLabel="Job Title"
                                                        className="input"
                                                        maxLength={60}
                                                    />
                                                </Form.Item>
                                            </div>
                                            <Button
                                                className="fields__btn"
                                                type="primary"
                                                onClick={handleSubmit}
                                                loading={signUpUserLoading}
                                            >
                                                {signUpUserLoading ? <Loader /> : 'Continue'}
                                            </Button>
                                        </Form>
                                    </div>
                                )}

                                {(data?.data?.role?.name === 'tender_representative' ||
                                    data?.data?.role?.title === 'Super Admin' ||
                                    data?.data?.role?.title === 'Onboarding Representative') && (
                                    <div className="signup__fields fields">
                                        <div
                                            className={
                                                data?.data.role?.name === 'super_admin'
                                                    ? 'role-admin'
                                                    : data?.data.role?.name === 'tender_representative'
                                                    ? 'role-tr'
                                                    : 'role-or'
                                            }
                                            style={
                                                data?.data?.role?.title === 'Super Admin'
                                                    ? { background: '#001965', color: 'white', width: '100px' }
                                                    : {}
                                            }
                                        >
                                            {data?.data?.role?.title}
                                        </div>
                                        <div className="fields__subtitle">All fields are mandatory</div>
                                        <Form form={form} onFinish={handleSubmit}>
                                            <div className="fields__block">
                                                <div className="fields__row">
                                                    <Form.Item
                                                        className={`${
                                                            screenWidth > 600 ? 'small-input-wrapper' : 'input-wrapper'
                                                        }`}
                                                        name="first_name"
                                                        rules={yupSync('first_name', validationSchema, true)}
                                                    >
                                                        <FloatInput
                                                            floatLabel="First Name"
                                                            className="input"
                                                            maxLength={60}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item
                                                        className={`${
                                                            screenWidth > 600 ? 'small-input-wrapper' : 'input-wrapper'
                                                        }`}
                                                        name="last_name"
                                                        rules={yupSync('last_name', validationSchema, true)}
                                                    >
                                                        <FloatInput
                                                            floatLabel="Last Name"
                                                            className="input"
                                                            maxLength={60}
                                                        />
                                                    </Form.Item>
                                                </div>

                                                <Form.Item
                                                    className="input-wrapper"
                                                    name="email"
                                                    rules={yupSync('email', validationSchema, true)}
                                                >
                                                    <FloatInput
                                                        floatLabel="Email"
                                                        className="input"
                                                        maxLength={60}
                                                        required={true}
                                                        disabled={true}
                                                        onKeyPress={handleKeyPress}
                                                    />
                                                </Form.Item>
                                            </div>

                                            <Button className="fields__btn" type="primary" onClick={handleSubmit}>
                                                {signUpUserLoading ? <Loader /> : 'Continue'}
                                            </Button>
                                        </Form>
                                    </div>
                                )}
                                {isSupplier && (
                                    <div className="signup__fields fields">
                                        <div className="fields__row">
                                            <div className="fields__title">General Company Info</div>
                                        </div>
                                        <Form form={form} onFinish={handleSubmit} validateTrigger="onBlur">
                                            <div className="fields__block">
                                                <Form.Item
                                                    className="input-wrapper"
                                                    name="name"
                                                    rules={yupSync('name', validationSchema, true)}
                                                >
                                                    <FloatInput
                                                        floatLabel="Full Name of Legal Entity"
                                                        className="input"
                                                        maxLength={128}
                                                        required={true}
                                                        onBlur={() => yupSync('name', validationSchema, true)}
                                                    />
                                                </Form.Item>
                                                <div className="fields__subtitle" style={{ margin: '-5px 0 20px 0' }}>
                                                    Use the official company name, including the registration type,
                                                    e.g., 'Company ABC (Pty) Ltd.'
                                                </div>
                                                <Form.Item
                                                    className="input-wrapper"
                                                    name="trading_name"
                                                    rules={yupSync('trading_name', validationSchema, true)}
                                                >
                                                    <FloatInput
                                                        floatLabel="Trading Name"
                                                        className="input"
                                                        maxLength={128}
                                                    />
                                                </Form.Item>
                                                <Form.Item
                                                    className="input-wrapper"
                                                    name="registration_num"
                                                    rules={yupSync('registration_num', validationSchema, true)}
                                                >
                                                    <PhoneNumberInput
                                                        floatLabel="Company Registration Number"
                                                        className="input"
                                                        maxLength={256}
                                                        value={data?.data?.registration_num}
                                                        placeholder={undefined}
                                                        required={true}
                                                        onChange={() =>
                                                            setError((prev) => ({ ...prev, registration_num: false }))
                                                        }
                                                        hasError={() => !!form.getFieldError('registration_num').length}
                                                        onBlur={() =>
                                                            yupSync('registration_num', validationSchema, true)
                                                        }
                                                        mask={'9999/999999/99'}
                                                        error={errors.registration_num}
                                                    />
                                                </Form.Item>
                                                {errors.registration_num && (
                                                    <div className="error-text" style={{ margin: '-10px 0 10px 0' }}>
                                                        Oops! It looks like that Registration Number is already
                                                        registered
                                                    </div>
                                                )}

                                                <Form.Item
                                                    className="input-wrapper"
                                                    name="website"
                                                    rules={yupSync('website', validationSchema, true)}
                                                >
                                                    <FloatInput
                                                        floatLabel="Website"
                                                        className="input"
                                                        maxLength={1024}
                                                        required={true}
                                                        disabled={false}
                                                        onKeyPress={handleKeyPress}
                                                    />
                                                </Form.Item>
                                                <div className="fields__subtitle" style={{ margin: '8px 0 16px 0' }}>
                                                    Select the expense areas you would like to receive Matchmaking
                                                    Journey notifications for
                                                </div>
                                                <Form.Item
                                                    className="input-wrapper-multiselect"
                                                    rules={yupSync('expense_areas', validationSchema, true)}
                                                >
                                                    <CustomMultiSelect
                                                        required={true}
                                                        floatLabel={'Expense Area/s'}
                                                        err={false}
                                                        options={filtredAreas}
                                                        onChange={(item: any) => {
                                                            selectItem(
                                                                item,
                                                                setFiltredAreas,
                                                                setSelectedArea,
                                                                selectedArea,
                                                                dataSchoolTypes?.data
                                                                    ?.supplier_questionnaire_expense_areas
                                                            );
                                                        }}
                                                        hasError={() => errors.expense_areas}
                                                        prefix={undefined}
                                                        value={selectedArea}
                                                        deleteItem={(id: string | number) =>
                                                            deleteItem(id, setSelectedArea, selectedArea)
                                                        }
                                                        deleteAllItems={setSelectedArea}
                                                        setTouched={(value) =>
                                                            setTouched((prev) => ({ ...prev, areas: value }))
                                                        }
                                                    />
                                                </Form.Item>
                                            </div>
                                            {errors.expense_areas && (
                                                <div className="error-text" style={{ margin: '-10px 0 10px 0' }}>
                                                    This is a required field
                                                </div>
                                            )}

                                            <div className="fields__block">
                                                <Form.Item
                                                    className="input-wrapper-multiselect"
                                                    rules={yupSync('provinces', validationSchema, true)}
                                                >
                                                    <CustomMultiSelect
                                                        required={true}
                                                        floatLabel={'Provincial Coverage'}
                                                        err={false}
                                                        options={filtredProvinnces}
                                                        onChange={(item: any) => {
                                                            selectItem(
                                                                item,
                                                                setFiltredProvinnces,
                                                                setSelectedProvinnces,
                                                                selectedProvinnces,
                                                                dataSchoolTypes?.data?.provinces
                                                            );
                                                        }}
                                                        hasError={() => errors.provinces}
                                                        prefix={undefined}
                                                        value={selectedProvinnces}
                                                        deleteItem={(id: string | number) => {
                                                            deleteItem(id, setSelectedProvinnces, selectedProvinnces);
                                                        }}
                                                        deleteAllItems={(e) => {
                                                            setSelectedProvinnces(e);
                                                        }}
                                                        setTouched={(value) =>
                                                            setTouched((prev) => ({ ...prev, provinces: value }))
                                                        }
                                                    />
                                                </Form.Item>
                                                {errors.provinces && (
                                                    <div className="error-text" style={{ margin: '-10px 0 10px 0' }}>
                                                        This is a required field
                                                    </div>
                                                )}
                                            </div>
                                            {/* redo */}
                                            <div className="fields__block">
                                                <Form.Item
                                                    className="input-wrapper"
                                                    rules={yupSync('sub_regions', validationSchema, true)}
                                                >
                                                    <CustomMultiSelect
                                                        required={true}
                                                        floatLabel={'Sub-Region'}
                                                        err={false}
                                                        options={filtredSubRegion}
                                                        onChange={(item: any) =>
                                                            selectItem(
                                                                item,
                                                                setFiltredSubRegion,
                                                                setSelectedSubRegions,
                                                                selectedSubRegions,
                                                                filtredSubRegion
                                                            )
                                                        }
                                                        hasError={() => errors.sub_regions}
                                                        prefix={undefined}
                                                        value={selectedSubRegions}
                                                        deleteItem={(id: string | number) =>
                                                            deleteItem(id, setSelectedSubRegions, selectedSubRegions)
                                                        }
                                                        deleteAllItems={setSelectedSubRegions}
                                                        setTouched={(value) =>
                                                            setTouched((prev) => ({ ...prev, sub_regions: value }))
                                                        }
                                                        disabled={!selectedProvinnces?.length}
                                                    />
                                                </Form.Item>
                                                {errors.sub_regions && (
                                                    <div className="error-text" style={{ margin: '-10px 0 10px 0' }}>
                                                        This is a required field
                                                    </div>
                                                )}
                                            </div>
                                            <div className="fields__block">
                                                <Form.Item
                                                    className="input-wrapper"
                                                    rules={yupSync('employees_number', validationSchema, true)}
                                                >
                                                    <FloatSelect
                                                        type="common"
                                                        required={true}
                                                        floatLabel={'# of Employees'}
                                                        err={false}
                                                        className="input-select"
                                                        setSearch={() => {}}
                                                        options={dataSchoolTypes?.data?.sc_employees_number}
                                                        onChange={setSelectedEmployees}
                                                        value={selectedEmployees}
                                                        search={''}
                                                        form={form}
                                                        hasError={() => errors.employees}
                                                        setTouched={(value) =>
                                                            setTouched((prev) => ({ ...prev, employees: value }))
                                                        }
                                                    />
                                                </Form.Item>
                                                {errors.employees && (
                                                    <div className="error-text" style={{ margin: '-10px 0 10px 0' }}>
                                                        This is a required field
                                                    </div>
                                                )}
                                            </div>
                                            <div className="fields__block">
                                                <div className="fields__row">
                                                    <Form.Item
                                                        className="small-input-wrapper"
                                                        rules={yupSync('annual_revenue', validationSchema, true)}
                                                    >
                                                        <FloatSelect
                                                            type="common"
                                                            required={true}
                                                            floatLabel={'Annual Revenue'}
                                                            err={false}
                                                            className="input-select"
                                                            setSearch={() => {}}
                                                            options={dataSchoolTypes?.data?.sc_annual_revenue}
                                                            onChange={setSelectedRevenue}
                                                            value={selectedRevenue}
                                                            search={''}
                                                            form={form}
                                                            hasError={() => errors.revenue}
                                                            setTouched={(value) =>
                                                                setTouched((prev) => ({ ...prev, revenue: value }))
                                                            }
                                                        />
                                                        {errors.revenue && (
                                                            <div
                                                                className="error-text"
                                                                style={{ margin: '33px 0 -55px 0' }}
                                                            >
                                                                This is a required field
                                                            </div>
                                                        )}
                                                    </Form.Item>
                                                    <Form.Item
                                                        className="small-input-wrapper"
                                                        rules={yupSync('b_bbee', validationSchema, true)}
                                                    >
                                                        <FloatSelect
                                                            type="common"
                                                            required={true}
                                                            floatLabel={'B-BBEE'}
                                                            err={false}
                                                            className="input-select"
                                                            setSearch={() => {}}
                                                            options={dataSchoolTypes?.data?.sc_b_bbee}
                                                            onChange={setSelectedBbee}
                                                            value={selectedBbee}
                                                            search={''}
                                                            form={form}
                                                            hasError={() => errors.bbee}
                                                            setTouched={(value) =>
                                                                setTouched((prev) => ({ ...prev, bbee: value }))
                                                            }
                                                        />
                                                        {errors.bbee && (
                                                            <div
                                                                className="error-text"
                                                                style={{ margin: '33px 0 -55px 0' }}
                                                            >
                                                                This is a required field
                                                            </div>
                                                        )}
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className="fields__block" style={{ margin: '10px 0 0 0' }}>
                                                <div className="fields__title">Is your company VAT registered?</div>
                                                <Form.Item className="small-input-wrapper">
                                                    <Radio.Group
                                                        name="radiogroup"
                                                        className="fields__radiogroup"
                                                        value={radio}
                                                        onChange={(e) => {
                                                            const v = e.target.value;
                                                            setRadio(v);
                                                            setTouched((prev) => ({ ...prev, radio: true }));
                                                            if (v !== 'yes') {
                                                                setVatNumberServerError(null);
                                                                setError((prev) => ({ ...prev, vat_number: false }));
                                                            }
                                                        }}
                                                    >
                                                        <Radio value={'yes'}>Yes</Radio>

                                                        <Radio value={'no'}>No</Radio>
                                                    </Radio.Group>
                                                    {errors.radio && (
                                                        <div className="error-text" style={{ margin: '0 0 10px 0' }}>
                                                            This is a required field
                                                        </div>
                                                    )}
                                                </Form.Item>

                                                {radio === 'yes' && (
                                                    <>
                                                        <Form.Item
                                                            className="input-wrapper"
                                                            name="vat_number"
                                                            rules={yupSync('vat_number', validationSchema, true)}
                                                        >
                                                            <PhoneNumberInput
                                                                floatLabel="VAT Registration Number"
                                                                className="input"
                                                                maxLength={256}
                                                                value={data?.data?.vat_number}
                                                                placeholder={undefined}
                                                                required={true}
                                                                onChange={() => {
                                                                    setVatNumberServerError(null);
                                                                    setError((prev) => ({
                                                                        ...prev,
                                                                        vat_number: false
                                                                    }));
                                                                }}
                                                                hasError={() =>
                                                                    !!form.getFieldError('vat_number').length
                                                                }
                                                                onBlur={() =>
                                                                    yupSync('vat_number', validationSchema, true)
                                                                }
                                                                mask={'9999999999'}
                                                                error={errors.vat_number}
                                                            />
                                                        </Form.Item>
                                                        {errors.vat_number && vatNumberServerError && (
                                                            <div
                                                                className="error-text"
                                                                style={{ margin: '-10px 0 10px 0' }}
                                                            >
                                                                {vatNumberServerError}
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                            <Button
                                                className="fields__btn"
                                                type="primary"
                                                onClick={handleSubmit}
                                                loading={signUpUserLoading}
                                            >
                                                {isLoadingCreateSupplier ? <Loader /> : 'Continue'}
                                            </Button>
                                        </Form>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {step === 'password' && (
                        <div className="main__block">
                            <div className="main__form form password">
                                <div className="form__title">Set up your password</div>

                                <div className="signup__fields fields">
                                    <Form form={form} onFinish={handleSubmit} validateTrigger="onBlur">
                                        <div className="fields__block">
                                            <Form.Item
                                                className="input-wrapper"
                                                name="password"
                                                rules={yupSync('password', validationSchema, true)}
                                            >
                                                <FloatInput
                                                    type="password"
                                                    floatLabel="Password (>8 characters)"
                                                    className="input"
                                                    maxLength={32}
                                                    onBlur={() => {
                                                        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
                                                        const res = passwordRegex.test(form.getFieldValue('password'));
                                                        if (!res && form.getFieldValue('password')) {
                                                            setPasswordErr(true);
                                                        } else {
                                                            setPasswordErr(false);
                                                        }
                                                    }}
                                                    onKeyPress={handleKeyPress}
                                                />
                                            </Form.Item>
                                            <div
                                                className="fields__label"
                                                style={
                                                    passwordErr ? { color: '#e80a0f', margin: '-24px 0 16px 0' } : {}
                                                }
                                            >
                                                {`The password should contain numbers and at least one upper case and lower case letter (>8 characters)`}
                                            </div>
                                            <Form.Item
                                                className="input-wrapper"
                                                name="confirmPassword"
                                                rules={[
                                                    ...yupSync('confirmPassword', validationSchema),
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            if (!value || getFieldValue('password') === value) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(
                                                                new Error('Oops! Your passwords do not match')
                                                            );
                                                        }
                                                    })
                                                ]}
                                                dependencies={['password']}
                                            >
                                                <FloatInput
                                                    type="password"
                                                    floatLabel="Repeat Password (>8 characters)"
                                                    className="input"
                                                    maxLength={32}
                                                    onKeyPress={handleKeyPress}
                                                />
                                            </Form.Item>
                                        </div>

                                        <Button className="fields__btn" type="primary" onClick={handleSubmit}>
                                            {signUpUserLoading ? <Loader /> : 'Create Account'}
                                        </Button>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    )}

                    {step === 'contact_info' && (
                        <div className="main__block">
                            <div className="main__form form">
                                <div className="form__title" style={{ margin: '0 0 40px 0' }}>
                                    Please complete the section Contact Info
                                </div>
                                <div className="signup__fields fields">
                                    <div className="fields__row">
                                        <div className="fields__title">Primary Contact</div>
                                    </div>
                                    <Form form={form} onFinish={handleSubmit} validateTrigger="onBlur">
                                        <div className="fields__block">
                                            <Form.Item
                                                className={`${screenWidth > 600 ? 'input-wrapper' : 'input-wrapper'}`}
                                                name="contact_name"
                                                rules={yupSync('contact_name', validationSchema, true)}
                                            >
                                                <FloatInput
                                                    floatLabel="Contact Name"
                                                    className="input"
                                                    maxLength={60}
                                                    required={true}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                className="input-wrapper"
                                                name="job"
                                                rules={yupSync('job', validationSchema, true)}
                                            >
                                                <FloatInput
                                                    floatLabel="Job Title"
                                                    className="input"
                                                    maxLength={60}
                                                    required={true}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                className="input-wrapper"
                                                name="phone_number"
                                                rules={yupSync('phone_number', validationSchema, true)}
                                            >
                                                <PhoneNumberInput
                                                    floatLabel="Contact Phone number"
                                                    className="input"
                                                    maxLength={256}
                                                    value={data?.data?.phone_number}
                                                    placeholder={undefined}
                                                    required={true}
                                                    onChange={() => {}}
                                                    hasError={() => !!form.getFieldError('phone_number').length}
                                                    onBlur={() => yupSync('phone_number', validationSchema, true)}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                className="input-wrapper"
                                                name="email"
                                                rules={yupSync('email', validationSchema, true)}
                                            >
                                                <FloatInput
                                                    floatLabel="Primary Email"
                                                    className="input"
                                                    maxLength={60}
                                                    required={true}
                                                    onKeyPress={handleKeyPress}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                className="input-wrapper"
                                                name="secondary_email"
                                                rules={yupSync('secondary_email', validationSchema, true)}
                                            >
                                                <FloatInput
                                                    floatLabel="Secondary Email"
                                                    className="input"
                                                    maxLength={60}
                                                    onKeyPress={handleKeyPress}
                                                />
                                            </Form.Item>
                                        </div>
                                        <div className="form__note">
                                            <img src={i} />
                                            <div>
                                                New Matchmaking Journey opportunities will be sent to both your primary
                                                and secondary email addresses. To ensure you don't miss out on any
                                                opportunities, we recommend providing a secondary email address that is
                                                continuously monitored.
                                            </div>
                                        </div>
                                        <Form.Item className="input-wrapper" name="agreement">
                                            <Checkbox checked={checkbox} onChange={() => setCheckbox((prev) => !prev)}>
                                                <div className="checkbox_text">
                                                    I agree to Proco the{' '}
                                                    <a
                                                        href="https://schooladvisor.co.za/privacy-notice"
                                                        target="_blank"
                                                        style={{
                                                            color: 'rgb(19 47 130)',
                                                            fontWeight: '600',
                                                            textDecoration: 'underline'
                                                        }}
                                                        rel="noreferrer"
                                                    >
                                                        Privacy Policy
                                                    </a>
                                                </div>
                                            </Checkbox>
                                        </Form.Item>
                                        {errors.agreement && (
                                            <div className="error-text" style={{ margin: '-10px 0 10px 0' }}>
                                                You need to agree to the Proco Privacy Policy
                                            </div>
                                        )}
                                    </Form>
                                </div>
                                <Button
                                    className="fields__btn"
                                    type="primary"
                                    onClick={handleSubmit}
                                    loading={signUpUserLoading}
                                >
                                    {isLoadingCreateSupplier ? <Loader /> : 'Submit Form'}
                                </Button>
                            </div>
                        </div>
                    )}
                    {step === 'questionary' && (
                        <div className="main__questionary questionary">
                            <div className="questionary__header">
                                <div className="questionary__header-block-1">
                                    <div className="questionary__title">
                                        Expense Area Questionnaire{' '}
                                        <Tooltip title="Your responses to this questionnaire will form the basis of all Matchmaking Journey submissions for the relevant expense area. Please answer truthfully and accurately. You may be assessed against the claims made here, and supporting evidence may be requested. Misleading responses can result in disqualification from current or future opportunities.">
                                            <div>
                                                <InfoIcon fill="#808CB2" />
                                            </div>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className="questionary__header-block-2">
                                    Your questionnaire autosaves. You can return anytime to complete it or update your
                                    profile.
                                </div>
                            </div>

                            <div className="questionary__main">
                                <div className="questionary__EAs">
                                    {list?.map((EA: any) => {
                                        const isLastSectionId = EA.last_section_id;
                                        const indexLastSectionId = EA?.sections.findIndex(
                                            (section: Section) => section.id === isLastSectionId + ''
                                        );
                                        const isSelectedComponents = EA.selected_components?.length;

                                        if (!isLastSectionId && +EA.expense_area_id !== +activeEA) {
                                            return (
                                                <div className="questionary__nextarea nextarea">
                                                    <div>
                                                        <img src={nextEaImage} />
                                                        {EA?.name}
                                                    </div>
                                                    <Arrow />
                                                </div>
                                            );
                                        } else {
                                            const isExpanded = !expandedAreas.includes(EA.expense_area_id);

                                            return (
                                                <div
                                                    className={`questionary__area area ${isExpanded ? '' : 'expanded'}`}
                                                >
                                                    {activeSectionId?.includes('components') &&
                                                        EA.expense_area_id + '' === activeEA + '' && (
                                                            <>
                                                                <div className="area__helper-text">
                                                                    Changing any answers may update or reset the
                                                                    following sections based on your new inputs.
                                                                    {/* <div className='area__helper-text'>Got it</div> */}
                                                                </div>
                                                            </>
                                                        )}
                                                    <div className="area__title">
                                                        {EA?.name}{' '}
                                                        <div onClick={() => toggleArea(EA.expense_area_id)}>
                                                            <Arrow
                                                                fill="#001965"
                                                                style={
                                                                    isExpanded ? { transform: 'rotate(-180deg)' } : {}
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className={`area__sections ${isExpanded ? 'expanded' : ''}`}>
                                                        {EA?.sections?.map((section: any, index: number) => {
                                                            const isComponents = section?.id?.includes('components');

                                                            const isDone = isComponents
                                                                ? isSelectedComponents
                                                                : index <= indexLastSectionId;
                                                            const isActive = section?.id + '' === activeSectionId + '';

                                                            return (
                                                                <>
                                                                    <div
                                                                        className={`area__section ${
                                                                            isActive
                                                                                ? 'active'
                                                                                : isDone
                                                                                ? 'done'
                                                                                : 'pending'
                                                                        }`}
                                                                    >
                                                                        {isDone &&
                                                                        section?.id + '' !== activeSectionId + '' ? (
                                                                            <div className="number_of_section">
                                                                                <img src={done} />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="number_of_section">
                                                                                {index + 1}
                                                                            </div>
                                                                        )}
                                                                        {section?.name}
                                                                    </div>
                                                                    {index !== EA?.sections?.length - 1 && (
                                                                        <div className="area__divider"></div>
                                                                    )}
                                                                </>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            );
                                        }
                                    })}
                                </div>
                                <div className="questionary__fields-section fields-section">
                                    {activeSectionId.includes('components') && (
                                        <div className="fields-section__components">
                                            <div className="fields-section__componentsHeader componentsHeader">
                                                <div className="componentsHeader__row">
                                                    <div className="componentsHeader__title">
                                                        <ServiceComIcon />
                                                        Service Components{' '}
                                                    </div>
                                                    <div className="componentsHeader__section-number">
                                                        Section 1 of{' '}
                                                        {
                                                            list?.find(
                                                                (elem: any) =>
                                                                    elem.expense_area_id + '' === activeEA + ''
                                                            )?.sections?.length
                                                        }
                                                    </div>
                                                </div>
                                                {/* <div className="componentsHeader__row desc">Form description</div> */}
                                            </div>
                                            <div className="fields-section__componentsMain componentsMain">
                                                <div className="componentsMain__title">
                                                    Select all types of service components that you have for{' '}
                                                    {EAData?.name}:
                                                </div>
                                                <div className="componentsMain__subtitle">
                                                    You can select several options. Some of answers open an additional
                                                    section of questions
                                                </div>
                                                {serverQuestionaryError && (
                                                    <div
                                                        className="error-text"
                                                        style={{ margin: '0 0 12px 0', whiteSpace: 'pre-line' }}
                                                    >
                                                        {serverQuestionaryError}
                                                    </div>
                                                )}
                                                <div className="componentsMain__questions">
                                                    {saveData?.map((field: any) => {
                                                        return (
                                                            <div className="componentsMain__item" key={field.id}>
                                                                <Checkbox
                                                                    onChange={() =>
                                                                        updateAnswer(field?.id, null, 'components')
                                                                    }
                                                                    checked={field?.answer === 'true' ? true : false}
                                                                    className={field?.error ? 'red' : ''}
                                                                />{' '}
                                                                {field?.name}{' '}
                                                                <Tooltip title={field?.description}>
                                                                    <div>
                                                                        <InfoIcon fill="#808CB2" />
                                                                    </div>
                                                                </Tooltip>
                                                                {field?.error && (
                                                                    <div className="error-text" style={{ marginTop: 4 }}>
                                                                        {field.errorMessage || 'Invalid selection'}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {!activeSectionId.includes('components') && (
                                        <div className="fields-section__components">
                                            <div className="fields-section__componentsHeader componentsHeader">
                                                <div className="componentsHeader__row">
                                                    <div className="componentsHeader__title">
                                                        <ServiceComIcon />
                                                        {
                                                            EAData?.sections?.find(
                                                                (item: Section) =>
                                                                    item?.id + '' === activeSectionId + ''
                                                            )?.name
                                                        }
                                                    </div>
                                                    <div className="componentsHeader__section-number">
                                                        Section{' '}
                                                        {EAData?.sections?.findIndex(
                                                            (item: Section) => item?.id + '' === activeSectionId + ''
                                                        ) + 1}{' '}
                                                        of{' '}
                                                        {
                                                            list?.find(
                                                                (elem: any) =>
                                                                    elem.expense_area_id + '' === activeEA + ''
                                                            )?.sections?.length
                                                        }
                                                    </div>
                                                </div>
                                                {EAData?.sections?.find(
                                                    (item: Section) => item?.id + '' === activeSectionId + ''
                                                )?.description && (
                                                    <div className="componentsHeader__row desc">
                                                        {
                                                            EAData?.sections?.find(
                                                                (item: Section) =>
                                                                    item?.id + '' === activeSectionId + ''
                                                            )?.description
                                                        }
                                                    </div>
                                                )}
                                            </div>
                                            <div>
                                                {serverQuestionaryError && (
                                                    <div
                                                        className="error-text"
                                                        style={{ margin: '0 0 12px 0', whiteSpace: 'pre-line' }}
                                                    >
                                                        {serverQuestionaryError}
                                                    </div>
                                                )}
                                                {saveData.map((field: QuestionAnswer) => {
                                                    const type = field?.type;

                                                    if (type === 'short-answer') {
                                                        return (
                                                            <ShortAnswer
                                                                field={field}
                                                                required={field.required}
                                                                updateAnswer={updateAnswer}
                                                                saveData={saveData}
                                                                component_id={null}
                                                            />
                                                        );
                                                    }
                                                    if (type === 'paragraph') {
                                                        return (
                                                            <Paragraph
                                                                field={field}
                                                                required={field.required}
                                                                updateAnswer={updateAnswer}
                                                                saveData={saveData}
                                                                component_id={null}
                                                            />
                                                        );
                                                    }
                                                    if (type === 'dropdown') {
                                                        return (
                                                            <Dropdown
                                                                field={field}
                                                                required={field.required}
                                                                updateAnswer={updateAnswer}
                                                                saveData={saveData}
                                                                component={field?.component_name}
                                                                component_id={field.component_id}
                                                            />
                                                        );
                                                    }
                                                    if (type === 'single-select') {
                                                        return (
                                                            <SingleSelect
                                                                field={field}
                                                                required={field.required}
                                                                updateAnswer={updateAnswer}
                                                                saveData={saveData}
                                                                component={field?.component_name}
                                                                component_id={field.component_id}
                                                            />
                                                        );
                                                    }
                                                    if (type === 'multiple-choice') {
                                                        return (
                                                            <MultipleChoice
                                                                field={field}
                                                                required={field.required}
                                                                updateAnswer={updateAnswer}
                                                                saveData={saveData}
                                                                component={field?.component_name}
                                                                component_id={field.component_id}
                                                            />
                                                        );
                                                    }
                                                    if (type === 'explanation-banner') {
                                                        return (
                                                            <ExplanationBanner
                                                                field={field}
                                                                required={field.required}
                                                                saveData={saveData}
                                                                component_id={null}
                                                            />
                                                        );
                                                    }
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="questionary__btns">
                                {(() => {
                                    const EAIndex = questionary?.findIndex(
                                        (elem: any) => elem.expense_area_id + '' === activeEA + ''
                                    );

                                    if (activeSectionId && activeSectionId?.includes('components')) {
                                        if (EAIndex === 0) {
                                            return (
                                                <>
                                                    <div></div>
                                                    <Button
                                                        type="primary"
                                                        onClick={() => syncEAtoComponentsFunc()}
                                                        disabled={saveData?.every((elem) => elem.answer === 'false')}
                                                    >
                                                        {isLoadingSyncComponents ? (
                                                            <Loader />
                                                        ) : (
                                                            <div className="questionary__btn">
                                                                Next Step <img src={arrowIcon} />
                                                            </div>
                                                        )}
                                                    </Button>
                                                </>
                                            );
                                        } else {
                                            return (
                                                <>
                                                    <Button onClick={() => goToPrevSection()}>Previous</Button>

                                                    <Button
                                                        type="primary"
                                                        onClick={() => syncEAtoComponentsFunc()}
                                                        disabled={saveData?.every((elem) => elem.answer === 'false')}
                                                    >
                                                        {isLoadingSyncComponents ? (
                                                            <Loader />
                                                        ) : (
                                                            <div className="questionary__btn">
                                                                Next Step <img src={arrowIcon} />
                                                            </div>
                                                        )}
                                                    </Button>
                                                </>
                                            );
                                        }
                                    } else {
                                        return (
                                            <>
                                                <Button onClick={() => goToPrevSection()}>Previous</Button>

                                                <Button
                                                    type="primary"
                                                    onClick={() => {
                                                        handleSaveFields();
                                                    }}
                                                >
                                                    {isLoadingsaveAnswers ? (
                                                        <Loader />
                                                    ) : (
                                                        <div className="questionary__btn">
                                                            Next Step <img src={arrowIcon} />
                                                        </div>
                                                    )}
                                                </Button>
                                            </>
                                        );
                                    }
                                })()}
                            </div>
                        </div>
                    )}
                    {step === 'supplier_created' && (
                        <div className="main__block">
                            <div className="main__form form">
                                <div className="form__title" style={{ margin: '0 0 40px 0' }}>
                                    Your registration request is in!{' '}
                                </div>
                                <div className="signup__fields fields">
                                    <div className="fields__row">
                                        <div className="fields__title">
                                            To complete the registration, please get the <br /> following documents
                                            ready:
                                        </div>
                                    </div>
                                    <ul>
                                        <li className="signup__li">Financial/Management Accounts</li>
                                        <li className="signup__li">B-BBEE Certificate/Affidavit</li>
                                        <li className="signup__li">SARS Letter of Good Standing</li>
                                        <li className="signup__li">Company Registration Certificate</li>
                                    </ul>
                                    <div className="signup__addtext">We’ll reach out within 72 hours</div>
                                </div>
                                <Button
                                    className="fields__btn"
                                    type="primary"
                                    onClick={() => (window.location.href = 'https://schooladvisor.co.za')}
                                    loading={signUpUserLoading}
                                >
                                    {signUpUserLoading ? <Loader /> : 'Back Home'}
                                </Button>
                            </div>
                        </div>
                    )}
                    {step === 'registration_request_is_in' && (
                        <div className="main__block">
                            <div className="main__form form">
                                <div className="form__title" style={{ margin: '0 0 40px 0' }}>
                                    Your registration request is in!{' '}
                                </div>
                                <div className="signup__fields fields">
                                    <div className="fields__row">
                                        <div className="fields__title">
                                            We’re reviewing your details. To complete your registration, you’ll receive
                                            an email from us with the Matchmaking Journey Participation Agreement.
                                            Please sign and return this agreement to finalise your registration.
                                        </div>
                                    </div>

                                    <div className="signup__addtext">
                                        You can expect to hear from us within 72 hours.
                                    </div>
                                </div>
                                <Button
                                    className="fields__btn"
                                    type="primary"
                                    onClick={() => (window.location.href = 'https://schooladvisor.co.za')}
                                    loading={signUpUserLoading}
                                >
                                    {signUpUserLoading ? <Loader /> : 'Back Home'}
                                </Button>
                            </div>
                        </div>
                    )}
                    {step === 'profile_updated_successfully' && (
                        <div className="main__block">
                            <div className="main__form form">
                                <div className="form__title" style={{ margin: '0 0 40px 0' }}>
                                    Profile updated successfully
                                </div>
                                <div className="signup__fields fields">
                                    <div className="fields__row">
                                        <div className="fields__title">
                                            Your profile has been updated. Buyers will use this information to evaluate
                                            your suitability and decide whether to include you in their shortlist.
                                        </div>
                                    </div>
                                </div>
                                <Button
                                    className="fields__btn"
                                    type="primary"
                                    onClick={() => (window.location.href = 'https://schooladvisor.co.za')}
                                    loading={signUpUserLoading}
                                >
                                    {signUpUserLoading ? <Loader /> : 'Back Home'}
                                </Button>
                            </div>
                        </div>
                    )}
                    {step === 'profile_updated_successfully_but_need_documents' && (
                        <div className="main__block">
                            <div className="main__form form">
                                <div className="form__title" style={{ margin: '0 0 40px 0' }}>
                                    Profile updated successfully
                                </div>
                                <div className="signup__fields fields">
                                    <div className="fields__row">
                                        <div className="fields__title">
                                            Your profile has been updated. Buyers will use this information to evaluate
                                            your suitability and decide whether to include you in their shortlist.
                                        </div>
                                    </div>
                                </div>
                                <Button
                                    className="fields__btn"
                                    type="primary"
                                    onClick={() => {
                                        const params = new URLSearchParams(location.search);
                                        let uploadDocs = searchParams.get('upload_documents') ?? '';
                                        if (!uploadDocs) {
                                            try {
                                                const qp = JSON.parse(
                                                    sessionStorage.getItem('questionary_params') || 'null'
                                                );
                                                if (qp?.upload_documents != null) {
                                                    uploadDocs = String(qp.upload_documents);
                                                }
                                            } catch {
                                                /* ignore */
                                            }
                                        }
                                        if (uploadDocs) {
                                            params.set('upload_documents', uploadDocs);
                                        }
                                        const qs = params.toString();
                                        navigate(`/supplier-company/verification${qs ? `?${qs}` : ''}`);
                                    }}
                                    loading={signUpUserLoading}
                                >
                                    Upload Documents
                                </Button>
                            </div>
                        </div>
                    )}
                    {step === 'notify-contact' && (
                        <div className="main__block">
                            <div className="main__form form">
                                <div className="form__title" style={{ margin: '0 0 40px 0' }}>
                                    Welcome back!
                                </div>

                                <div className="signup__fields fields" style={{ margin: '0 0 25px 0' }}>
                                    <div className="fields__row">
                                        <div className="fields__main-title">
                                            We’ve recognised your
                                            <br /> Company Registration Number
                                        </div>
                                    </div>
                                    <div className="fields__row">
                                        <div className="fields__title">
                                            It looks like you’ve already started with us. No worries — your progress has
                                            been saved.
                                            <br />
                                            <br /> To continue — whether you’re completing your registration or updating
                                            your company details — simply click the button below.
                                            <br />
                                            <br /> {createdData?.data?.contact?.email} <br />
                                            <br />
                                            Click the link in that email to confirm it’s you and we’ll take you straight
                                            back to your registration.
                                        </div>
                                    </div>
                                </div>
                                <Button
                                    className="fields__btn small"
                                    type="primary"
                                    onClick={() => {
                                        const postData = {
                                            registration_num: createdData?.data?.company?.registration_num
                                        };
                                        sendConfirmationCompanyEmail(postData);
                                    }}
                                >
                                    {loadingSendEmail ? <Loader /> : 'Send Confirmation Email'}
                                </Button>
                            </div>
                        </div>
                    )}
                    {step === 'email-sent' && (
                        <div className="main__block">
                            <div className="main__form form">
                                <div className="form__title" style={{ margin: '0 0 40px 0' }}>
                                    Email sent – check your inbox{' '}
                                </div>

                                <div className="signup__fields fields" style={{ margin: '0 0 25px 0' }}>
                                    <div className="fields__row">
                                        <div className="fields__title">
                                            We’ve sent a confirmation email to:
                                            <br />
                                            <br /> {createdData?.data?.contact?.email} <br />
                                            <br />
                                            To continue your registration or update your information, please click the
                                            link in the email.
                                        </div>
                                    </div>
                                    <div className="fields__subtitle">
                                        Didn’t get it? Make sure to check your spam or promotions folder.
                                    </div>
                                </div>
                                <div className="fields__btn-wrapper">
                                    <Button
                                        className="fields__btn small"
                                        type="primary"
                                        onClick={() => {
                                            const postData = {
                                                registration_num: createdData?.data?.company?.registration_num
                                            };
                                            sendConfirmationCompanyEmail(postData);
                                        }}
                                        disabled={isButtonDisabled}
                                    >
                                        {loadingSendEmail ? <Loader /> : 'Resend Email'}
                                    </Button>
                                    {isButtonDisabled ? (
                                        <div className="fields__timer">
                                            <img src={timerIcon} alt="timer" />
                                            <span>
                                                <CountdownTimer
                                                    duration={60}
                                                    callback={() => setIsButtonDisabled(false)}
                                                />
                                            </span>
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                                <div className="fields__btn-back" onClick={() => setStep('general')}>
                                    <ArrowLeft fill={'#001965'} />
                                    Back to Registration Form
                                </div>
                            </div>
                        </div>
                    )}

                    {step !== 'questionary' && (
                        <div className={`main__block ${screenWidth < 1280 ? 'image' : ''}`}>
                            <div className={step === 'general' ? 'general' : 'password'}>
                                {step === 'general' && <img src={general} className="image__item" />}
                                {step === 'password' && <img src={password} className="image__item" />}
                                {step === 'contact_info' && <img src={ContactInfoIcon} className="image__item" />}
                                {step === 'supplier_created' && <img src={supplierCreated} className="image__item" />}
                                {step === 'notify-contact' && <img src={WelcomeBackIcon} className="image__item" />}
                                {step === 'email-sent' && <img src={EmailSentImage} className="image__item" />}
                                {step === 'registration_request_is_in' && (
                                    <img src={RegistrationDone} className="image__item" />
                                )}
                                {step === 'profile_updated_successfully' && (
                                    <img src={RegistrationDone} className="image__item" />
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};
